import { IContactIOS } from "../types/contacts"
import { IRecipient } from "../store/slices/c2cSlice"
import { PHONE_PREFIX } from "./constants"

export const formatPhoneNumber = (inputPhoneNumber: string) => {
  const formattedNumber = inputPhoneNumber.replace(
    /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/,
    "+$1 $2 $3-$4-$5",
  )
  return formattedNumber
}

export const formatPhoneNumberInput = (input: string) => {
  // Если первая цифра 7, то добавляем в ее начало +
  if (input === "7") {
    return PHONE_PREFIX
  }

  // Удаление всех нечисловых символов из ввода
  let numericInput = input.replace(/\D/g, "")
  // Удаляем временно +7
  numericInput = numericInput.replace(/^7/, "")

  // Обрезаем максимальную длинну
  if (numericInput.length > 10) {
    numericInput = numericInput.slice(0, 10)
  }

  // Применение формата телефона
  const formattedPhoneNumber = numericInput.replace(
    /(\d{1,3})(\d{0,3})(\d{0,2})(\d{0,2})(\d{0,2})/,
    `${PHONE_PREFIX} $1 $2 $3 $4 $5`,
  )

  return formattedPhoneNumber.trim()
}

// Форматирование номера телефона для прохождения серверной валидации (приведение к формату +7XXXXXXXXXX)
export const formatPhoneValidation = (input: string) =>
  `${input.replace(/\D/g, "")}`

export const formatAmount = (amount: string | number) => {
  const amountString = amount.toString()
  if (amountString.indexOf(",") > -1) {
    const [integerPart, decimalPart] = amountString.split(",")
    const formattedIntegerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      " ",
    )
    const formattedDecimalPart = decimalPart.replace(/0+$/, "")
    if (formattedDecimalPart === "") {
      return formattedIntegerPart
    }
    return `${formattedIntegerPart},${formattedDecimalPart}`
  }
  return amountString.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

export const formatIosContacts = (
  contacts: IContactIOS[],
): IRecipient[] =>
  contacts.map((iosContact) => {
    const { identifier, givenName, familyName, phoneNumbers } = iosContact
    const phone = phoneNumbers.find((phoneItem) => phoneItem.value)?.value || ""

    return {
      id: identifier,
      name: familyName?.length ? `${givenName} ${familyName}` : givenName,
      phone,
    }
  })

export const formatPassport = (input: string) => {
  let digitsOnly = input.replace(/\D/g, "")

  if (digitsOnly.length > 10) {
    digitsOnly = digitsOnly.slice(0, 10)
  }

  const formatedPassport = digitsOnly.replace(/(\d{1,4})(\d{0,6})/, "$1 $2")

  return formatedPassport.trim()
}

export const formatName = (input: string) => {
  const nameInput = input.replace(/\d/g, "")
  return nameInput
}

// Форматирование кода подразделения паспорта в формате ddd-ddd
export const formatPassportIssuerCode = (input: string) => {
  let digitsOnly = input.replace(/\D/g, "")

  if (digitsOnly.length > 6) {
    digitsOnly = digitsOnly.slice(0, 6)
  }

  const formattedCode = digitsOnly.replace(/(\d{1,3})(\d{0,3})/, (match, p1, p2) => {
    if (p2) {
      return `${p1}-${p2}`
    }
    return p1
  })

  return formattedCode
}


